export default function getNamePath(url){
    const arrayStr=url.split('/')
    const index=arrayStr.length-1
    return arrayStr[index]
}
